import { OCRDetailUIModel } from "src/store/models/ui/ocr/ocrDetail";
import { OCRSideUIModel } from "src/store/models/ui/ocr/ocrSide";
import { OCRTableUIModel } from "src/store/models/ui/ocr/ocrTable";

export const encooOCRUIModels = {
  ocrTable: OCRTableUIModel,
  ocrSide: OCRSideUIModel,
  ocrDetail: OCRDetailUIModel,
};
